module.exports = __webpack_public_path__ + "instruction-physical-good.f54b57f9.png";